/*
  Sign-up tracking for inline Shopify Forms (e.g. the newsletter page).

  Pushes the same dataLayer event as the custom popups, so the existing GTM
  tag sends it to GA4 as generate_lead with popup_name set to the name below.
  The marketing dashboard reads sign-ups per form from that.

  Forms renders into an open shadow root and switches data-current-step to
  "success" once a submit goes through, so that is what counts as a sign-up.
  Forms inside an hm-popup are skipped: that section tracks its own.
*/
(function() {
  // Shopify Forms id -> name sent as popup_name. Unlisted forms are sent as
  // shopify_form_<id>.
  var NAMES = {
    '929700': 'newsletter_page'
  };

  function formName(embed) {
    var root = embed.closest('[data-forms-id]');
    var match = root && /(\d+)$/.exec(root.getAttribute('data-forms-id'));
    if (!match) return null;
    return NAMES[match[1]] || 'shopify_form_' + match[1];
  }

  function watch(embed) {
    if (embed.dataset.hmTracked || embed.closest('.hm-popup')) return;
    var shadow = embed.shadowRoot;
    var name = formName(embed);
    if (!shadow || !name) return;
    embed.dataset.hmTracked = 'true';

    var sent = false;
    new MutationObserver(function() {
      var step = shadow.querySelector('[data-current-step]');
      if (sent || !step || step.getAttribute('data-current-step') !== 'success') return;
      sent = true;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'generate_lead', popup: name });
    }).observe(shadow, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-current-step'] });
  }

  // Forms hydrates its embeds a moment after load, so look for a while.
  (function find(tries) {
    document.querySelectorAll('shopify-forms-embed').forEach(watch);
    if (tries < 40) window.setTimeout(function() { find(tries + 1); }, 250);
  })(0);
})();
